import { z } from 'zod';

export const TrentPositionSubmitFailedSchema = z.object({
    positionId: z.string().uuid(),
    positionNumber: z.string(),
    issues: z.string().array(),
    message: z.string().optional(),
});

export type TrentPositionSubmitFailed = z.infer<typeof TrentPositionSubmitFailedSchema>;
